import Request from './request';
// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

async function fetch(data) {// 获取列表
    return Request('get', "api/quotations/", data);
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/quotations/" + id, data);
}

async function confirm(id, data) {
    return Request("post", "api/quotations/confirm/" + id, data)
}

async function question(id, data) {
    return Request("post", "api/quotations/question/" + id, data)
}

async function approve(id) {
    return Request("post", "api/quotations/approve/" + id)
}

async function cancel(id) {
    return Request("post", "api/quotations/cancel/" + id)
}

async function getEconomyHistory(data) {
    return Request("get", "api/quotations/get-economy-history/", data)
}

async function economyHistoryExport(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request("get", "api/quotations/economy-history-export/", data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

export default {
    fetch,
    fetchOne,
    confirm,
    question,
    approve,
    cancel,
    getEconomyHistory,
    economyHistoryExport,
};